import { useEffect, useState } from 'react';

/**
 * Hook to detect if the current viewport is mobile size
 * Based on ShadCN/UI's use-mobile hook pattern
 * Uses 768px as the breakpoint (md breakpoint in Tailwind)
 */
export function useMobile() {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 767px)');
    const onChange = () => {
      setIsMobile(window.innerWidth < 768);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < 768);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
}
